module.exports = __webpack_public_path__ + "static/img/noRoom.30e7fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/word/noRoom.png
// module id = plRs
// module chunks = 3